/**
 * The hand-off from a learner page to the player (job #46, Tom 2026-09-24:
 * one bottom nav on every screen).
 *
 * The bar on /talk, /groups, /games and the rest is the SAME BottomNav the
 * player mounts, but the player is not on screen there, so a Library, Settings
 * or mode tap cannot act directly. It leaves the intent here and goes to `/`;
 * PlayerContainer takes it once on mount and does exactly what the same tap
 * does in the player. Module state, not a query string, so nothing is left in
 * the address bar for a refresh to replay.
 */
import { ref } from 'vue'

export type PlayerIntent = 'library' | 'settings' | 'listening' | 'script' | 'offline' | 'sector'

const pending = ref<PlayerIntent | null>(null)

export function requestPlayerIntent(intent: PlayerIntent | null): void {
  pending.value = intent
}

/** Read and clear: an intent is acted on once, never replayed. */
export function takePlayerIntent(): PlayerIntent | null {
  const i = pending.value
  pending.value = null
  return i
}
